import React from 'react';
import { StarIcon } from 'lucide-react';
import { Button, TrustBar } from './Shared';
const STATS = [{
  value: '+300',
  label: 'familias confían'
}, {
  value: '6',
  label: 'tomos listos'
}, {
  value: '4.9/5',
  label: 'calificación'
}, {
  value: '🇺🇾',
  label: 'todo Uruguay'
}];
const HERO_TESTIMONIALS = [{
  initials: 'VG',
  quote: 'Mi hijo me pide la etiqueta del jueves.',
  author: 'Valentina G., Montevideo',
  tag: 'Mamá de 9 años'
}, {
  initials: 'MF',
  quote: 'Desde que uso el sistema mi hijo come todo.',
  author: 'Marcela F., Rivera',
  tag: 'Mamá de 7 años'
}, {
  initials: 'LM',
  quote: 'Me sacó esa sensación para siempre.',
  author: 'Laura M., Montevideo',
  tag: 'Mamá de 5 años'
}];
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-lightBlue px-4 pb-16 pt-8 text-center md:pb-20 md:pt-12" data-id="element-64" data-mp="nbydopvr4v83">
      <div className="mx-auto w-full max-w-5xl" data-id="element-65" data-mp="3cz5w0drpe41e">
        <p className="mb-3 flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-brand-orange md:mb-5 md:text-sm" data-id="element-66" data-mp="381e0zavri1sz">
          🌟 Tu Fénix Digital
        </p>
        <h1 className="mx-auto max-w-4xl font-display text-4xl font-bold leading-[1.08] text-brand-deep sm:text-5xl md:text-6xl lg:text-7xl" data-id="element-67" data-mp="3o6kg9kdpcg66">
          Meriendas deliciosas y saludables{' '}
          <span className="text-brand-orange" data-id="element-68" data-mp="3e8ms0wvuejdk">sin perder tiempo</span>
          <br data-id="element-69" data-mp="30i1abbi4kfh9" />
          en la cocina.
        </h1>
        <p className="mt-5 font-display text-base font-bold uppercase tracking-[0.17em] text-brand-blue md:text-lg" data-id="element-70" data-mp="30h9eq0oj2hqz">
          Meriendas que Acompañan
        </p>

        <div className="mx-auto my-7 max-w-[280px] sm:max-w-md md:my-9 md:max-w-lg" data-id="element-71" data-mp="2qkdcgcp82ruv">
          <img src="https://cdn.magicpatterns.com/uploads/6MvDBad2Cc5yMfAKgLFa9m/mockup_MERIENDA_QUE_ACOMPANAN.png" alt="Mockup del Mega Pack Meriendas que Acompañan con 6 tomos y 3 bonos" width="1440" height="1440" fetchPriority="high" decoding="async" className="w-full rounded-[2rem] shadow-[0_20px_50px_rgba(13,59,110,0.18)]" data-id="element-72" data-mp="2viomoojfj4dm" />
        </div>

        <p className="mx-auto max-w-3xl text-base font-medium leading-relaxed text-brand-text md:text-xl" data-id="element-73" data-mp="s2tdvmncibq9">
          El sistema que usan las familias uruguayas para resolver la merienda escolar de toda la semana en una sola tarde y dejar de cargar con esa sensación de culpa todos los días de no saber que hacer.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-2 md:mt-8 md:gap-3" data-id="element-74" data-mp="db2d7as4g7l5">
          {['📄 100% PDF', '⚡ Acceso inmediato', "Para familias uruguayas"].map(pill => <span key={pill} className="rounded-full border border-brand-sky bg-white px-4 py-2 text-xs font-semibold text-brand-blue shadow-sm md:text-sm" data-id="element-75" data-mp="162ufx5fcjp7b">
              {pill}
            </span>)}
        </div>
        <div className="mx-auto mt-7 max-w-md" data-id="element-76" data-mp="x0cugt7in0ld">
          <Button className="py-5" data-id="element-77" data-mp="3lsypyre788fd">
            🌟 QUIERO MI MEGAPACK AHORA — $390 UYU
          </Button>
        </div>
        <div className="mt-4" data-id="element-78" data-mp="3hqtynzb83nvw">
          <TrustBar data-id="element-79" data-mp="3hpsdv34enn0z" />
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4" data-id="element-80" data-mp="3htpwzoqzgekv">
          {STATS.map(stat => <div key={stat.label} className="rounded-2xl border border-brand-sky bg-white px-3 py-5 shadow-sm" data-id="element-81" data-mp="1x7hy7ki4cf41">
              <p className="font-display text-3xl font-bold text-brand-blue md:text-4xl" data-id="element-82" data-mp="26a9atnmqdgx9">
                {stat.value}
              </p>
              <p className="mt-1 text-sm font-medium leading-tight text-brand-text" data-id="element-83" data-mp="2b1hjuik5f09w">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="mt-10 grid gap-4 text-left md:grid-cols-3" data-id="element-84" data-mp="2kynbpt0l6vb6">
          {HERO_TESTIMONIALS.map(testimonial => <article key={testimonial.initials} className="flex flex-col rounded-2xl border border-slate-100 bg-white p-5 shadow-sm" data-id="element-85" data-mp="2ozz426auhun2">
              <div className="mb-3 flex text-yellow-400" aria-label="5 de 5 estrellas" data-id="element-86" data-mp="2tyaa05y0rl00">
                {Array.from({
              length: 5
            }).map((_, star) => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-87" data-mp="zlauectn2qsq" data-mpi={star} />)}
              </div>
              <p className="flex-1 font-semibold text-brand-deep" data-id="element-88" data-mp="4b45noxezwhc">
                “{testimonial.quote}”
              </p>
              <div className="mt-5 flex items-center gap-3" data-id="element-89" data-mp="3vigoe8dy4hzd">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-blue text-sm font-bold text-white" data-id="element-90" data-mp="3vk1mu93dsl2i">
                  {testimonial.initials}
                </span>
                <span data-id="element-91" data-mp="98mezgfcgdpv">
                  <strong className="block text-sm text-brand-text" data-id="element-92" data-mp="3hpr180mol70o">
                    {testimonial.author}
                  </strong>
                  <small className="text-brand-gray" data-id="element-93" data-mp="3csqwbt1kiab5">{testimonial.tag}</small>
                </span>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}